<template>
  <div class="modal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Tambah Komersial</h4>
          <button type="button" class="btn btn-sm" v-on:click="closeModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" v-if="komersialData">
          <div class="horizontal">
            <div class="column5"></div>
            <div class="column100">Bidang</div>
          </div>
          <div class="horizontal" v-for="(item, index) in komersial" :key="index">
            <div class="column5">
              <input class="modal-input-checkbox" type="checkbox" :id="index" :value="item.id"
                v-model="komersial[index]['checked']" />
            </div>
            <div class="column100">{{ item.desc }}</div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" v-on:click="closeModal()">
            Selesai
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      komersial: [],
    }
  },
  computed: {
    // komersialData: async function() {
    //   let getLegal = await this.$getLegal()

    //   getLegal = await getLegal.filter(i => i.type == 2)
    //   const defaultKomersial = await this.$store.state.landingpage
    //     .addedKomersial

    //   let reduceKomersial = await getLegal.reduce(
    //     (a, b) => ({ ...a, [b.id]: b }),
    //     {}
    //   )
    //   let reduceDefault =
    //     (await defaultKomersial) &&
    //     defaultKomersial.reduce((a, b) => ({ ...a, [b.id]: b }), {})

    //   let combine = { ...reduceKomersial, ...reduceDefault }

    //   let newKomersial = await Object.values(combine)
    //   this.komersial = newKomersial.sort((a, b) => this.$sortAsc(a, b))
    //   console.log('komersialll', this.komersial);

    // },
    komersialData: async function () {
      let getLegal = await this.$getLegal();

      getLegal = await getLegal.filter(i => i.type == 2);

      const defaultKomersial = await this.$store.state.landingpage.addedKomersial;


      let reduceKomersial = await getLegal.reduce(
        (a, b) => ({ ...a, [b.id]: b }),
        {}
      );
      let reduceDefault =
        (await defaultKomersial) &&
        defaultKomersial.reduce((a, b) => ({ ...a, [b.id]: b }), {});

      let combine = { ...reduceKomersial, ...reduceDefault };

      let newKomersial = await Object.values(combine);

      const selectedIds = [5, 6, 8, 9, 10, 34];
      newKomersial = newKomersial.map((item) => {
        if (selectedIds.includes(item.id)) {
          return { ...item, checked: true };
        }
        return item;
      });
      this.komersial = newKomersial.sort((a, b) => this.$sortAsc(a, b));
    },
    filteredKomersial: function () {
      const filtered =
        this.komersial &&
        this.komersial.filter(i => i.checked && i.checked == true)
      return filtered
    },
  },
  methods: {
    async closeModal() {
      let newData = []
      let filterKomersial = this.komersial
      // (await this.komersial) &&
      // this.komersial.filter(i => i.checked && i.checked == true)

      let checkNpwp = await filterKomersial.filter(
        i => i.desc == 'NPWP (NOMOR POKOK WAJIB PAJAK)'
      )

      if (checkNpwp.length > 0) {
        let newNpwp = checkNpwp[0]
        let newFilter = filterKomersial.filter(
          i => i.desc != 'NPWP (NOMOR POKOK WAJIB PAJAK)'
        )

        newNpwp['keterangan'] = this.$store.state.landingpage.npwpBank
        newData = [...newFilter, newNpwp]
        filterKomersial = newData
      }

      await this.$store.commit('landingpage/SET_LANDINGPAGE_MODAL', {
        name: 'addKomersial',
        status: false,
      })
      await this.$store.commit('landingpage/SET_CHECKED', {
        name: 'addedKomersial',
        filter: filterKomersial,
      })
    },
  },
}
</script>
<style scoped>
.modal {
  width: 100vw;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: block;
  overflow: hidden;
  outline: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

.modal-dialog {
  width: 100vw;
  background-color: green;
}

.modal-content {
  width: 90vw;
  position: absolute;
  transform: translateX(-30%);
}

.modal-body {
  height: 50vh;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.modal-input-checkbox {
  margin-right: 20px;
}
</style>
